import { SelectionActionType, SelectionActions } from './actions';

export interface SelectionState {
  selectedStops: Array<string>;
  selectedDrivers: Array<string>;
  selectedClients: Array<string>;
  selectedVehicles: Array<string>;
  selectedSupervisors: Array<string>;
}

export const getInitialState = (): SelectionState => ({
  selectedStops: [],
  selectedDrivers: [],
  selectedClients: [],
  selectedVehicles: [],
  selectedSupervisors: [],
});

export const SelectionReducer = (state: SelectionState, action: SelectionActions): SelectionState => {
  switch (action.type) {
    case SelectionActionType.SET_ACTIVE_PLAN_SELECTED_STOPS:
      return {
        ...state,
        selectedStops: action.payload.selectedStops,
      };
    case SelectionActionType.SET_ACTIVE_PLAN_SELECTED_DRIVERS:
      return {
        ...state,
        selectedDrivers: action.payload.selectedDrivers,
      };
    case SelectionActionType.SET_SELECTED_CLIENTS:
      return {
        ...state,
        selectedClients: action.payload.selectedClients,
      };
    case SelectionActionType.SET_SELECTED_VEHICLES:
      return {
        ...state,
        selectedVehicles: action.payload.selectedVehicles,
      };
    case SelectionActionType.SET_SELECTED_SUPERVISORS:
      return {
        ...state,
        selectedSupervisors: action.payload.selectedSupervisors,
      };
    case SelectionActionType.ON_SELECT_STOP: {
      const { stopId, withControlKey } = action.payload;
      let selectedStops = [stopId];

      if (withControlKey) {
        selectedStops = state.selectedStops.includes(stopId)
          ? state.selectedStops.filter((id) => id !== stopId)
          : [...state.selectedStops, stopId];
      }

      return {
        ...state,
        selectedStops,
      };
    }
    case SelectionActionType.ON_SELECT_DRIVER: {
      const { driverId, withControlKey } = action.payload;
      let selectedDrivers = [driverId];

      if (withControlKey) {
        selectedDrivers = state.selectedDrivers.includes(driverId)
          ? state.selectedDrivers.filter((id) => id !== driverId)
          : [...state.selectedDrivers, driverId];
      }

      return {
        ...state,
        selectedDrivers,
      };
    }
    default:
      return state;
  }
};
